export default {"src":"/_next/static/media/nav-logo-vertical.44301448.svg","height":134,"width":178,"blurWidth":0,"blurHeight":0};